import React from "react";

import { cn } from "@/lib/utils";

/** Small status pill used in rows ("Bokad · 3 pass", "Har ansökt", …). */
const StatusPill: React.FC<{
	color: "green" | "blue" | "orange" | "red" | "gray";
	children: React.ReactNode;
}> = ({ color, children }) => (
	<span
		className={cn(
			"inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 type-label font-medium",
			color === "green" && "bg-green-100 text-green-800",
			color === "blue" && "bg-blue-100 text-blue-800",
			color === "orange" && "bg-orange-100 text-orange-900",
			color === "red" && "bg-red-100 text-red-700",
			color === "gray" && "bg-gray-200 text-gray-700"
		)}
	>
		{children}
	</span>
);

export default StatusPill;
